import { render, staticRenderFns } from "./NavigationDrawerListGroupAccount.vue?vue&type=template&id=87962fdc"
import script from "./NavigationDrawerListGroupAccount.vue?vue&type=script&lang=ts"
export * from "./NavigationDrawerListGroupAccount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports